import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { environment } from "../../../environments/environment";
import { resetCompanyFontOptions, setCompanyFontOptions } from "../../shared/constants/document.constants";

interface CompanyFontFile {
  weight: string;
  url: string;
}

interface CompanyFont {
  label: string;
  value: string;
  family: string;
  files: CompanyFontFile[];
}

@Injectable({ providedIn: "root" })
export class CompanyFontsService {
  private url = environment.apiUrl + "/eva/company-fonts";
  private loadedCompanyId: string | null = null;
  private loading: Promise<void> | null = null;

  constructor(private http: HttpClient) {}

  load(evaCompanyId: string): Promise<void> {
    if (this.loading && this.loadedCompanyId === evaCompanyId) return this.loading;
    if (this.loadedCompanyId !== evaCompanyId) resetCompanyFontOptions();
    this.loadedCompanyId = evaCompanyId;
    this.loading = this.fetchAndRegister(evaCompanyId);
    return this.loading;
  }

  private async fetchAndRegister(evaCompanyId: string): Promise<void> {
    try {
      const fonts = await firstValueFrom(this.http.get<CompanyFont[]>(this.url));
      const faces: FontFace[] = [];
      for (const font of fonts) {
        for (const file of font.files) {
          const buffer = await firstValueFrom(
            this.http.get(environment.apiUrl + file.url, { responseType: "arraybuffer" }),
          );
          const face = new FontFace(font.family, buffer, { weight: file.weight === "bold" ? "700" : "400" });
          await face.load();
          faces.push(face);
        }
      }
      if (this.loadedCompanyId !== evaCompanyId) return;
      const fontSet = document.fonts as FontFaceSet & { add(face: FontFace): void };
      faces.forEach((face) => fontSet.add(face));
      setCompanyFontOptions(fonts.map(({ label, value }) => ({ label, value })));
    } catch (error) {
      console.error("Chargement des polices société impossible", error);
      if (this.loadedCompanyId === evaCompanyId) this.loading = null;
    }
  }
}
